import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=44815e84&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=44815e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44815e84",
  null
  
)

export default component.exports